import { classNames } from "../../../utils/classNames";
import goalMockup from "../../../images/donation-goal-mockup.png";

export const TutorialCard = () => {
  return (
    <div
      className={classNames(
        "bg-[#F8F9FF] py-6 px-8 rounded-[20px] relative pl-[300px] mb-8"
      )}
    >
      <div className="flex items-center">
        <div>
          <h2 className="text-base font-bold mb-2">
            اولین بار است که میخواهید هدف ایجاد کنید؟
          </h2>
          <p className="text-sm opacity-80 leading-6">
            هدف حمایت مالی ابزاری است که به شما کمک می کند تا برای پروژه های خود
            هدف مالی ایجاد کنید و از طریق آن از حمایت کنندگان خود حمایت های مالی
            دریافت کنید.
          </p>
        </div>
        <img src={goalMockup} className="-mt-4 absolute top-0 left-7" />
      </div>
    </div>
  );
};
